<template>
  <v-simple-table
    :height="tableHeight"
    fixed-header
  >
    <template v-slot:default>
      <thead>
        <tr>
          <th v-for="(header, index) in headers" :key="index" :colspan="header.colspan || 1">
            {{ header.text }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(isCollapsed, itemListGroupIdx) in itemListingData.isCollapsed">
          <template v-if="isCollapsed">
            <tr v-for="(row, rowIndex) in itemListingData.collapse[itemListGroupIdx]">
              <template v-for="(cell, cellIndex) in row">
                <td
                  v-if="cell.collapseAction"
                  :rowspan="cell.rowspan || 1"
                >
                  <v-btn
                    small
                    icon
                    @click="toggleRowCollapse(itemListGroupIdx)"
                  >
                    <v-icon>{{ isCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                  </v-btn>
                </td>
                <td
                  v-else
                  :key="cellIndex"
                  :rowspan="cell.rowspan || 1"
                  :colspan="cell.colspan || 1"
                  :style="getCellStyle(cell)"
                  @click="openEditDialog('item_listing', itemListGroupIdx, cellIndex, cell, rowIndex)"
                  style="cursor: pointer;"
                >
                  {{ cell.value.toString().startsWith("__") ? "" : cell.value }}
                </td>
              </template>
            </tr>
          </template>
          <template v-else>
            <tr v-for="(row, rowIndex) in itemListingData.expand[itemListGroupIdx]">
              <template v-for="(cell, cellIndex) in row">
                <td
                  v-if="cell.collapseAction"
                  :rowspan="cell.rowspan || 1"
                >
                  <v-btn
                    small
                    icon
                    @click="toggleRowCollapse(itemListGroupIdx)"
                  >
                    <v-icon>{{ isCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                  </v-btn>
                </td>
                <td
                  v-else
                  :key="cellIndex"
                  :rowspan="cell.rowspan || 1"
                  :colspan="cell.colspan || 1"
                  :style="getCellStyle(cell)"
                  @click="openEditDialog('item_listing', itemListGroupIdx, cellIndex, cell, rowIndex)"
                  style="cursor: pointer;"
                >
                  {{ cell.value.toString().startsWith("__") ? "" : cell.value }}
                </td>
              </template>
            </tr>
          </template>
          <tr>
            <td
              bgcolor='#DDDDDD'
              colspan=11
              style="border-top: 1px solid rgb(0, 0, 0); border-bottom: 1px solid rgb(0, 0, 0);"
            >
            </td>
          </tr>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'TaskResultItemListing',
  props: {
    tableHeight: {
      type: String,
      required: true
    },
    itemListingData: {
      type: Object,
      required: true
    },
    getCellStyle: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      headers: [
        { text: 'Invoice', colspan: 3 },
        { text: 'Packing', colspan: 3 },
        { text: 'Bill Lading', colspan: 3 },
        { text: 'Match?', colspan: 1 },
        { text: '', colspan: 1 }
      ],
    }
  },
  methods: {
    toggleRowCollapse(rowIndex) {
      this.$emit('toggle-row-collapse', rowIndex)
    },
    openEditDialog(tableType, groupIndex, cellIndex, cell, rowIndex) {
      this.$emit('open-edit-dialog', tableType, groupIndex, cellIndex, cell, rowIndex)
    }
  }
}
</script>

<style scoped>
:deep(.v-data-table__wrapper table th) {
  text-align: center !important;
}
td {
  border: 1px solid #ddd;
  padding: 8px;
}
td[style*="background-color"] {
  color: #fff;
}
:deep(.v-data-table__wrapper table) {
  border-collapse: collapse;
}
</style>
